export default "__VITE_ASSET__BAskNw4n__"